
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["turnOff","calculateUnitPlan"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "8124972082721455b9c4.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			